import { render, staticRenderFns } from "./TransportScholarship.vue?vue&type=template&id=4fb88604&scoped=true"
import script from "./TransportScholarship.vue?vue&type=script&lang=js"
export * from "./TransportScholarship.vue?vue&type=script&lang=js"
import style0 from "./TransportScholarship.vue?vue&type=style&index=0&id=4fb88604&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb88604",
  null
  
)

export default component.exports